import { z } from 'zod';
import { baseObjectSchema, baseSchema } from '../baseSchemas';

export const getMaterialsDCSchema = z.array(
  baseObjectSchema.extend({
    materialID: z.string(),
    distributionChannelID: z.string(),
    material: baseSchema,
    distributionChannel: z.any().optional(),
  })
);

export type GetMaterialsDCResponse = z.infer<typeof getMaterialsDCSchema>;
